import React from "react";
import { Provider } from "react-redux";
import { Template as TabFeatureAttributeBlockTemplate } from "tsi-common-react/src/templates/TabFeatureAttributeBlockTemplate";

import { templates } from "@reactivated";

import { store } from "../src/store";

// Use tempurpedic provider with the common component
export const Template = (props: templates.TabFeatureAttributeBlockTemplate) => {
    return (
        <Provider store={store}>
            <TabFeatureAttributeBlockTemplate {...props} />
        </Provider>
    );
};
